import React from 'react';
import { motion } from 'framer-motion';

const AffiliateDisclosure = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  const contactBlock = (
    <div className="bg-[#F9FFF5] border border-[#2E7D32]/20 p-6 rounded-lg mt-2">
      <p><strong>Sam's Nutri Hub</strong></p>
      <p>Venkatesh Prime, 4th Floor, Burudgaon Road</p>
      <p>Ahmednagar, Maharashtra 414001</p>
      <p>Email: <a href="mailto:hello@samsnutrihub.com" className="text-[#2E7D32] hover:underline">hello@samsnutrihub.com</a></p>
      <p>Phone: <a href="tel:+919637375555" className="text-[#2E7D32] hover:underline">+91 96373 75555</a></p>
    </div>
  );

  return (
    <div className="bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <motion.div {...fadeInUp}>
          <p className="text-sm text-[#9E9E9E] mb-2">Last updated: November 1, 2023</p>
          <h1 className="text-4xl font-bold text-[#0B1320] font-poppins mb-10">
            Affiliate Disclosure — Sam's Nutri Hub
          </h1>

          <div className="prose prose-lg max-w-none text-[#4A4A4A] leading-relaxed space-y-8">

            <section>
              <p>
                Transparency is important to us. This Affiliate Disclosure explains our relationships with
                third-party brands and how we may earn compensation through affiliate partnerships.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">1. Affiliate Links</h2>
              <p>
                Some pages on this website contain affiliate links — links to products and services that are
                not owned or operated by Sam's Nutri Hub. If you click on an affiliate link and make a
                purchase, we may receive a small commission at no additional cost to you.
              </p>
              <p className="mt-4">
                These commissions help support the running of this website and allow us to continue
                providing free educational content, tips, and resources to our community.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">2. Our Affiliate Partnerships</h2>
              <p>
                We maintain affiliate or referral partnerships with select brands whose products we
                genuinely use, recommend, or believe add value to our community's health journey.
                These include:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>
                  <strong>Herbalife</strong> — a global nutrition company offering meal replacement
                  shakes, protein supplements, and wellness products
                </li>
                <li>
                  <strong>Select fitness and wellness brands</strong> — offering exercise equipment,
                  nutrition supplements, and related health products
                </li>
              </ul>
              <p className="mt-4">
                We only recommend products that we believe are genuinely beneficial. Our affiliate
                relationships do not influence the nutritional or wellness advice we provide to clients.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">3. No Additional Cost to You</h2>
              <p>
                When you purchase through an affiliate link, the price you pay is exactly the same as if
                you had found the product independently. In some cases, we may be able to offer you an
                exclusive discount through our affiliate partnership.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">4. Our Commitment to Honesty</h2>
              <p>
                We are committed to honest, unbiased recommendations. We will always disclose when content
                contains affiliate links, and we will never recommend a product solely because it pays us a
                commission. Our primary obligation is to our clients and community.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">5. Amendments</h2>
              <p>
                We reserve the right to modify this Affiliate Disclosure at any time. Changes will be
                posted on this page with an updated date. Please review this page periodically.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">6. Contact Us</h2>
              <p>
                If you have any questions about our affiliate relationships or this disclosure, please
                contact us:
              </p>
              {contactBlock}
            </section>

          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default AffiliateDisclosure;